var map = {
	"./gopay.png": "98ff",
	"./payment_icon_banktransfer.png": "b013",
	"./payment_icon_csobgtw.png": "d037",
	"./payment_icon_gopay.png": "c174",
	"./payment_icon_gpwebpay.png": "e581"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9da7";